<template>
  <b-container class="py-4 py-md-5 px-3 px-md-0 animate-fade-in">
    <!-- KHỐI 1: HEADER & LIÊN HỆ -->
    <header class="mb-4 mb-md-5 border-bottom pb-4">
      <b-row align-v="center">
        <b-col
          cols="12"
          md="3"
          class="text-center mb-3 mb-md-0 order-first order-md-last"
        >
          <b-img
            :src="require('@/assets/image-hauphvn.jpg')"
            rounded="circle"
            alt="Phạm Văn Hậu"
            class="shadow-sm profile-img border border-vue"
          ></b-img>
        </b-col>

        <b-col cols="12" md="9" class="text-left mb-4 mb-md-0">
          <h1 class="h2 text-vue-dark font-weight-bold mb-1 responsive-title">
            PHẠM VĂN HẬU
          </h1>
          <h2
            class="h5 text-vue-green font-weight-normal mb-3 responsive-subtitle"
          >
            Product Builder & Full-stack Developer
          </h2>
          <p class="text-muted text-justify responsive-lead mb-0">
            Lập trình viên Full-stack với năng lực tự nghiên cứu nghiệp vụ thực
            tế, trực tiếp thiết kế kiến trúc hệ thống, cấu hình hạ tầng chịu tải
            và triển khai môi trường Production ổn định. Có thế mạnh vượt trội
            trong việc phát triển ứng dụng Desktop đa nền tảng, xây dựng Backend
            xử lý lõi API và tự động hóa vận hành trên đám mây.
          </p>
        </b-col>
      </b-row>

      <!-- Hàng chứa thông tin liên hệ phụ bên dưới (Bản cập nhật đầy đủ Địa chỉ & GitHub) -->
      <b-row class="mt-4">
        <b-col cols="12">
          <div
            class="p-3 bg-white shadow-sm rounded border border-vue d-flex flex-column flex-md-row justify-content-between align-items-center gap-3"
          >
            <div
              class="text-vue-dark font-weight-bold mb-1 mb-md-0 small text-uppercase flex-shrink-0"
            >
              📇 Liên hệ:
            </div>
            <div class="text-truncate mb-1 mb-md-0">
              📧
              <a
                href="mailto:hauphvn@gmail.com"
                class="text-vue-dark font-weight-bold"
                >hauphvn@gmail.com</a
              >
            </div>
            <div class="mb-1 mb-md-0 flex-shrink-0">
              📱
              <a href="tel:+84967900801" class="text-vue-dark font-weight-bold"
                >+84 967 90 0801</a
              >
            </div>
            <div class="mb-1 mb-md-0 flex-shrink-0">
              🐱
              <a
                href="https://github.com/hauphvn"
                target="_blank"
                class="text-vue-dark font-weight-bold"
                >github.com/hauphvn</a
              >
            </div>
            <div class="mb-1 mb-md-0 text-center text-md-left small-content">
              📍
              <span class="text-vue-dark font-weight-bold"
                >944 Huỳnh Tấn Phát, Phú Thuận, Quận 7, HCM</span
              >
            </div>
          </div>
        </b-col>
      </b-row>
    </header>

    <section class="mb-4 mb-md-5">
      <h4 class="text-vue-dark font-weight-bold mb-3 mb-md-4">🛠️ Kỹ Thuật</h4>
      <b-row>
        <b-col
          cols="12"
          md="6"
          class="mb-3"
          v-for="(tech, index) in techMatrix"
          :key="index"
        >
          <b-card class="h-100 shadow-sm border-0 bg-white card-custom">
            <h5
              class="card-title font-weight-bold text-vue-green small-title mb-2"
            >
              {{ tech.title }}
            </h5>
            <p class="card-text text-dark font-weight-wide mb-0 small-content">
              {{ tech.items }}
            </p>
          </b-card>
        </b-col>
      </b-row>
    </section>

    <section class="mb-4 mb-md-5">
      <h4 class="text-vue-dark font-weight-bold mb-3 mb-md-4">
        💼 Kinh Nghiệm Làm Việc
      </h4>
      <b-list-group class="shadow-sm border-0">
        <b-list-group-item
          class="p-3 p-md-4 border-0 mb-3 bg-white rounded card-custom"
          v-for="exp in experience"
          :key="exp.company"
        >
          <div
            class="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-2"
          >
            <h5 class="font-weight-bold text-vue-dark mb-2 mb-md-0 small-title">
              {{ exp.role }} — {{ exp.company }}
            </h5>
            <b-badge class="px-3 py-1 badge-vue-light mb-2 mb-md-0"
              >{{ exp.period }}
            </b-badge>
          </div>
          <p class="text-muted small text-justify mb-0">{{ exp.desc }}</p>
        </b-list-group-item>
      </b-list-group>
    </section>

    <section class="mb-4 mb-md-5">
      <h4 class="text-vue-dark font-weight-bold mb-3 mb-md-4">
        🚀 Hệ Thống Sản Phẩm Đã Triển Khai
      </h4>
      <b-row>
        <b-col cols="12" class="mb-4">
          <b-card class="shadow-sm border-0 p-2 p-md-3 bg-vue-dark text-white">
            <b-row align-v="center">
              <b-col cols="12" lg="8" class="mb-3 mb-lg-0">
                <h5 class="font-weight-bold text-warning mb-2 small-title">
                  Ứng dụng Client-side độc lập chạy máy cảm ứng POS
                </h5>
                <p class="small text-light-80 text-justify mb-3">
                  Chạy tại cửa hàng. Tích hợp tính năng Silent Print (In ngầm
                  K80) đẩy cấu trúc hóa đơn trực tiếp ra driver in nhiệt không
                  qua hộp thoại hệ thống. Bảo mật mã hóa Token JWT lưu trữ bằng
                  API safeStorage của hệ điều hành. Thiết lập luồng CI/CD GitHub
                  Actions phối hợp Wrangler CLI tự động đẩy file cài đặt lên
                  Cloudflare R2; kết hợp electron-updater tự tải ngầm và cập
                  nhật đè siêu tốc tại quầy bán.
                </p>
                <div class="d-flex flex-column flex-sm-row gap-2">
                  <b-button
                    variant="light"
                    class="mb-2 mb-sm-0 font-weight-bold text-vue-dark py-2 py-md-1 mr-sm-2"
                    >📥 Tải Bản Windows (.exe)
                  </b-button>
                  <b-button
                    variant="outline-light"
                    class="font-weight-bold py-2 py-md-1"
                    >📥 Tải Bản Mac (.dmg)
                  </b-button>
                </div>
              </b-col>

              <!-- Cột bên phải: Khu vực Demo Automation & AI -->
              <b-col
                cols="12"
                lg="4"
                class="text-lg-right text-center border-left-lg"
              >
                <div
                  class="p-2 rounded bg-dark-transparency text-left text-lg-right"
                >
                  <span
                    class="d-block font-weight-bold text-vue-green small mb-1"
                    >🤖 Automation & AI Platform</span
                  >
                  <p
                    class="text-light-80 small mb-3 text-justify text-lg-right line-height-sm"
                  >
                    Hệ thống tự động hóa quy trình vận hành chuỗi và tích hợp
                    AI. Demo xử lý luồng dữ liệu thông minh kết nối trực tiếp
                    với OpenAI Platform.
                  </p>
                  <b-button
                    href="https://automation-test-v1.kaykafe.com/"
                    target="_blank"
                    variant="success"
                    block
                    class="font-weight-bold btn-vue-green py-2"
                  >
                    ⚙️ Open n8n UI Sandbox
                  </b-button>
                </div>
              </b-col>
            </b-row>
          </b-card>
        </b-col>

        <b-col
          cols="12"
          sm="6"
          md="4"
          class="mb-3 mb-md-4"
          v-for="proj in webProjects"
          :key="proj.id"
        >
          <b-card no-body class="h-100 border-0 shadow-sm bg-white card-custom">
            <b-card-body class="p-3 p-md-4">
              <h5 class="font-weight-bold text-vue-dark mb-2 small-title">
                {{ proj.title }}
              </h5>
              <p class="card-text text-muted small mb-0 text-justify">
                {{ proj.desc }}
              </p>
            </b-card-body>
            <b-card-footer
              class="bg-transparent border-0 pt-0 pb-3 pb-md-4 px-3 px-md-4"
            >
              <b-button
                :href="proj.url"
                target="_blank"
                variant="outline-vue"
                block
                class="btn-outline-vue py-2 py-md-1"
              >
                Truy cập ứng dụng
              </b-button>
            </b-card-footer>
          </b-card>
        </b-col>
      </b-row>
    </section>

    <section>
      <h4 class="text-vue-dark font-weight-bold mb-3 mb-md-4">🎓 Học Vấn</h4>
      <b-card class="shadow-sm border-0 bg-white p-2 card-custom">
        <div
          class="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center"
        >
          <div class="mb-2 mb-md-0">
            <h5 class="font-weight-bold text-vue-dark mb-1 small-title">
              Trường Đại học Khoa học Tự nhiên TP.HCM
            </h5>
            <p class="text-muted mb-0 small">
              Chuyên ngành: Công nghệ Thông tin
            </p>
          </div>
          <b-badge class="badge-vue-light px-3 py-1">2015 - 2019</b-badge>
        </div>
      </b-card>
    </section>
  </b-container>
</template>

<script>
export default {
  name: "HauPhanProfile",
  data() {
    return {
      techMatrix: [
        {
          title: "DESKTOP & FRONTEND",
          items:
            "Vue 2 (Options API), BootstrapVue, React 19, Next.js, Electron (v3.0.2), JavaFX, Tailwind v4, TanStack Start",
        },
        {
          title: "BACKEND & LOGIC",
          items:
            ".NET Core API, Node.js, C#, Dapper, Entity Framework, SignalR Hub",
        },
        {
          title: "DATABASE & CACHE",
          items:
            "PostgreSQL, SQLite Cục bộ, Redis Caching, Tối ưu hóa truy vấn",
        },
        {
          title: "HẠ TẦNG & BẢO MẬT",
          items:
            "Cloudflare R2, DevOps CI/CD Actions, Wrangler, SafeStorage, Docker, n8n",
        },
      ],
      experience: [
        {
          company: "Kaykafe",
          role: "DevOps Engineer",
          period: "2020 - 2026",
          desc: "Chịu trách nhiệm thiết kế hạ tầng, thiết lập CI/CD, tự động hóa quy trình vận hành chuỗi và trực tiếp triển khai môi trường Production/Staging cho toàn bộ hệ sinh thái phần mềm lõi của doanh nghiệp.",
        },
        {
          company: "PhucKhangNet",
          role: "Backend Developer",
          period: "2023 - 2026",
          desc: "Xây dựng kiến trúc hệ thống lõi (Core Logic), phát triển RESTful API hiệu năng cao, tối ưu cơ sở dữ liệu và xử lý các bài toán tích hợp cổng thanh toán, hóa đơn điện tử tự động kết nối với API bên thứ ba và dữ liệu cơ quan thuế.",
        },
        {
          company: "CMC Global",
          role: "Frontend Developer",
          period: "2019 - 2023",
          desc: "Tập trung phát triển giao diện người dùng (UI/UX) cho các dự án quy mô lớn, tối ưu hóa tốc độ tải trang (SEO), xây dựng các ứng dụng Web đa nền tảng và kiến trúc Mobile-First đáp ứng tiêu chuẩn quốc tế nghiêm ngặt.",
        },
      ],
      webProjects: [
        {
          id: 1,
          title: "ERP Core Management",
          desc: "Hệ thống quản trị chuỗi cung ứng kho hàng, tính lương nhân viên và xuất hóa đơn điện tử tự động kết nối API tổng cục thuế.",
          url: "https://dev.kaykafe-web-management.pages.dev",
        },
        {
          id: 2,
          title: "CRM Front Facing",
          desc: "Web phục vụ khách hàng đặt món siêu tốc (Mobile-first). Đồng bộ hóa đăng nhập OTP tích điểm thành viên và ví voucher.",
          url: "https://preview-cus.kaykafe.com",
        },
        {
          id: 3,
          title: "Tax Invoice Portal",
          desc: "Cổng tự động hóa vận hành: Cho phép khách hàng tự quét mã QR trên bill giấy từ máy POS để tự kích hoạt xuất hóa đơn VAT trong ngày.",
          url: "https://xuathoadon.kaykafe.com",
        },
      ],
    };
  },
};
</script>

<style scoped>
.text-vue-green {
  color: #42b883 !important;
}

.text-vue-dark {
  color: #35495e !important;
}

.bg-vue-dark {
  background-color: #35495e !important;
}

.border-vue {
  border-color: rgba(66, 184, 131, 0.25) !important;
}

.card-custom {
  border-left: 4px solid #42b883 !important;
}

.badge-vue-light {
  background-color: rgba(66, 184, 131, 0.1) !important;
  color: #42b883 !important;
  font-weight: 600;
}

.btn-vue-dark {
  background-color: #35495e !important;
  border-color: #35495e !important;
  color: #fff !important;
}

.btn-vue-dark:hover {
  background-color: #2c3e50 !important;
}

.btn-outline-vue {
  color: #42b883 !important;
  border-color: #42b883 !important;
}

.btn-outline-vue:hover {
  background-color: #42b883 !important;
  color: #fff !important;
}

@media (max-width: 576px) {
  .responsive-title {
    font-size: 1.85rem !important;
    text-align: center;
  }

  .responsive-subtitle {
    font-size: 1.1rem !important;
    text-align: center;
  }

  .responsive-lead {
    font-size: 0.95rem !important;
  }

  .small-title {
    font-size: 1.05rem !important;
  }

  .small-content {
    font-size: 0.9rem !important;
  }
}

.animate-fade-in {
  animation: fadeIn 0.4s ease-out;
}

.text-light-80 {
  color: rgba(255, 255, 255, 0.85);
}

.bg-dark-transparency {
  background-color: rgba(0, 0, 0, 0.2);
}

.line-height-sm {
  line-height: 1.35;
}

.btn-vue-green {
  background-color: #42b883 !important;
  border-color: #42b883 !important;
}

.btn-vue-green:hover {
  background-color: #3aa372 !important;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(6px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (min-width: 992px) {
  .border-left-lg {
    border-left: 1px solid rgba(255, 255, 255, 0.1) !important;
  }
}
</style>
